module.exports = __webpack_public_path__ + "static/circle-ea2de6b9ba5d33a6412b99be60bf583f.svg";